import { bffInstance } from "../api/axiosInstance";
import { useQuery } from "react-query";

export const fetchCspUrls = async () => {
  const response = await bffInstance.get(`/cspurls`);
  return response.data;
};

export function useCspUrls() {
  const { data } = useQuery({
    queryKey: ["cspurls"],
    queryFn: fetchCspUrls,
  });

  return { data };
}
